(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["10"] && !Shopify.designMode) return;
  try {
    
  /* Dermalight header: smooth scroll to a section (and the section fades in), the phone/tablet menu, and the cart count.
     Delegated listeners, so it also works for sections added or re-rendered in the theme editor. */
  (function () {
    if (window.__dlHeaderReady) return;
    window.__dlHeaderReady = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

    // height of the compact sticky bar, so a section a link jumps to is not hidden under it
    function headerOffset() {
      var h = document.querySelector('[data-dl-header]');
      if (!h || h.hasAttribute('data-dl-nosticky')) return 0;
      var cs = window.getComputedStyle(h);
      var pad = parseFloat(cs.getPropertyValue('--dl-stuck-pad')) || 14;
      var logo = parseFloat(cs.getPropertyValue('--dl-logo-h')) || 42;
      return Math.round(Math.max(44, logo) + pad * 2 + 1);
    }

    function scrollToY(y, done) {
      if (reduce) { window.scrollTo(0, y); if (done) done(); return; }
      var start = window.pageYOffset, dist = y - start, t0 = null;
      var dur = Math.min(1100, Math.max(550, Math.abs(dist) * 0.45));
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        window.scrollTo(0, start + dist * ease(p));
        if (p < 1) window.requestAnimationFrame(step); else if (done) done();
      }
      window.requestAnimationFrame(step);
    }

    function arrive(target) {
      target.classList.remove('dl-nav-arrive');
      void target.offsetWidth;                // restart the animation if it was just played
      target.classList.add('dl-nav-arrive');
      window.setTimeout(function () { target.classList.remove('dl-nav-arrive'); }, 1400);
    }

    function closeMenu(nav) {
      if (!nav) return;
      nav.classList.remove('is-open');
      var b = nav.querySelector('[data-dl-burger]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var burger = e.target.closest('[data-dl-burger]');
      if (burger) {
        var nav = burger.closest('[data-dl-nav]');
        var open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', String(open));
        return;
      }

      var link = e.target.closest('a[href^="#"]');
      var inScope = link && link.closest('[data-dl-nav], .dl-hero, .dl-cardsec, .dl-about, .dl-footer');
      if (!link || !inScope) {
        // a click anywhere else closes an open menu
        var opened = document.querySelector('[data-dl-nav].is-open');
        if (opened && !e.target.closest('[data-dl-nav]')) closeMenu(opened);
        return;
      }
      var hash = link.getAttribute('href');
      if (hash.length < 2) return;
      var target = null;
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { target = null; }
      if (!target) return;                    // no such section on this page: let the browser do its normal thing

      e.preventDefault();
      closeMenu(link.closest('[data-dl-nav]'));
      var y = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerOffset());
      scrollToY(y, function () {
        arrive(target);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (err2) { /* old browser */ }
        if (window.history && history.pushState) history.pushState(null, '', hash);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var opened = document.querySelector('[data-dl-nav].is-open');
      if (opened) { closeMenu(opened); var b = opened.querySelector('[data-dl-burger]'); if (b) b.focus(); }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) Array.prototype.forEach.call(document.querySelectorAll('[data-dl-nav].is-open'), closeMenu);
    });

    // sticky bar state + scroll-spy: highlight the menu link of the section that is on screen
    var spyQueued = false;
    function setupSticky() {
      var h = document.querySelector('[data-dl-header]');
      if (!h) return;
      var wrap = h.closest('.shopify-section');
      if (wrap && !h.hasAttribute('data-dl-nosticky')) wrap.classList.add('dl-header-sticky');
      document.documentElement.style.setProperty('--dl-header-offset', headerOffset() + 'px');
    }
    function update() {
      spyQueued = false;
      var h = document.querySelector('[data-dl-header]');
      if (!h) return;
      var sticky = !h.hasAttribute('data-dl-nosticky');
      h.classList.toggle('is-stuck', sticky && window.pageYOffset > 24);

      var links = h.querySelectorAll('a.dl-header__link');
      var line = headerOffset() + window.innerHeight * 0.3;   // a section counts as current once its top passes this line
      var here = location.pathname.replace(/\/$/, '');
      var best = null, bestTop = -Infinity;
      Array.prototype.forEach.call(links, function (a) {
        if (!a.hash || a.hash.length < 2 || a.pathname.replace(/\/$/, '') !== here) return;
        var el = null;
        try { el = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (err) { el = null; }
        if (!el) return;
        var top = el.getBoundingClientRect().top;
        if (top <= line && top > bestTop) { best = a; bestTop = top; }
      });
      Array.prototype.forEach.call(links, function (a) {
        var on = a === best;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'location');
        else if (!a.classList.contains('is-current')) a.removeAttribute('aria-current');
      });
    }
    function queueUpdate() {
      if (spyQueued) return;
      spyQueued = true;
      window.requestAnimationFrame(update);
    }
    function init() { setupSticky(); update(); }
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', function () { setupSticky(); queueUpdate(); });
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    window.addEventListener('load', init);

    // arriving from a store page through "/#protocol": the section fades in too
    window.addEventListener('load', function () {
      if (location.hash.length < 2) return;
      var t = null;
      try { t = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (err) { t = null; }
      if (t) window.setTimeout(function () { arrive(t); }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["4"] && !Shopify.designMode) return;
  try {
    
  /* Cards: only one is highlighted at a time. Delegated, so it works for sections added in the theme editor. */
  (function () {
    if (window.__dlCardsReady) return;
    window.__dlCardsReady = true;

    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('[data-dl-cards] .dl-card') : null;
      if (!card) return;
      var all = card.closest('[data-dl-cards]').querySelectorAll('.dl-card');
      Array.prototype.forEach.call(all, function (c) {
        var on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', String(on));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["8"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dlRevealReady) return;
    window.__dlRevealReady = true;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.documentElement.classList.add('dl-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    function scan() {
      Array.prototype.forEach.call(document.querySelectorAll('.dl-reveal:not(.is-visible)'), function (el) { io.observe(el); });
    }
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9"] && !Shopify.designMode) return;
  try {
    
  /* Scroll-in reveal for Dermalight sections: items with .dl-reveal fade up when they enter the screen.
     Skipped in the theme editor (everything stays visible while you edit) and for visitors who prefer reduced motion. */
  (function () {
    if (window.__dlRevealReady) return;
    window.__dlRevealReady = true;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.documentElement.classList.add('dl-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    function scan() {
      Array.prototype.forEach.call(document.querySelectorAll('.dl-reveal:not(.is-visible)'), function (el) { io.observe(el); });
    }
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
